/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {IsInstrumentLinkDenylistedRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/IsInstrumentLinkDenylisted.pb'
import {IsInstrumentLinkDenylistedResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/IsInstrumentLinkDenylisted.pb'


export const isInstrumentLinkDenylisted = (request: IsInstrumentLinkDenylistedRequest, options?: CashRequestOptions) => post<IsInstrumentLinkDenylistedRequest, IsInstrumentLinkDenylistedResponse>("/2.0/cash/is-instrument-link-denylisted", request, {...options, rejectOnError: true })